import cx from 'classnames';
import s from './styles.scss';
import * as enums from '../../enums';
import { ButtonProps } from './types';
import { ButtonLink } from './ButtonLink';
import { ButtonScroll } from './ButtonScroll';
import { ButtonAnchor } from './ButtonAnchor';

const Button = ({
  children,
  className,
  variant = enums.Variant.DEFAULT,
  color = enums.ColorTheme.PRIMARY,
  size = enums.Size.MEDIUM,
  disabled = false,
  hasError = false,
  ...restProps
}: ButtonProps): JSX.Element => {
  const buttonCx = cx(
    s.button,
    s[size],
    s[variant],
    s[color],
    { [s.disabled]: disabled },
    { [s.error]: hasError },
    className
  );

  return (
    <button
      role="button"
      aria-disabled={disabled}
      className={buttonCx}
      tabIndex={disabled ? -1 : 0}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
};

Button.Link = ButtonLink;
Button.Scroll = ButtonScroll;
Button.Anchor = ButtonAnchor;

export { Button };
